const getRoleSchema = (members, member) => {
  const roleSchema = {
    type: 'object',
    required: ['name', 'selectedRole'],
    properties: {
      name: {
        title: member ? 'Edit role name' : 'Role name',
        type: 'string',
      },
    },
  };

  if (!member) {
    roleSchema.properties.selectedRole = {
      title: 'Copy permissions from',
      type: 'string',
      oneOf: members.map((role) => ({
        enum: [role.type],
        title: role.type,
      })),
    };
  }

  return roleSchema;
};

const getPermissionsSchema = (allPermissions, includeList) => ({
  type: 'object',
  properties: Object.fromEntries(
    allPermissions
      .toSorted((a, b) => a.localeCompare(b))
      .map((permission) => [
        permission,
        {
          type: 'array',
          items: {
            type: 'boolean',
          },
          includeList,
        },
      ])
  ),
});

const getPermissionsUiSchema = (allPermissions) =>
  Object.fromEntries(
    allPermissions.map((permission) => [permission, { 'ui:field': 'permissionsSelector' }])
  );

export { getRoleSchema, getPermissionsSchema, getPermissionsUiSchema };
